// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Syne:wght@400;700;800&family=DM+Mono:wght@400;500&family=Source+Serif+4:ital,wght@0,400;0,600;0,700;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tutorial4.css  —  Updated with Diagram Styles
   ============================================================ */

   /* ─── Design tokens ─────────────────────────────────────────── */
   :root {
     --t4-bg:              #eef2f0;
     --t4-surface:         #ffffff;
     --t4-panel:           #f4f6f2;
     --t4-card:            #ffffff;
     --t4-sidebar-bg:      #eaece8;
     --t4-sidebar-header:  #e0e4de;
     --t4-code-bg:         #f7f9f5;
     --t4-eq-bg:           #f4f7f3;
   
     --t4-accent:          #2c5f2d;
     --t4-accent-dim:      rgba(44, 95, 45, 0.08);
     --t4-accent-glow:     rgba(44, 95, 45, 0.18);
     --t4-accent-hover:    #1e3f1f;
   
     --t4-amber:           #d4a017;
     --t4-amber-dim:       rgba(212, 160, 23, 0.10);
     --t4-amber-border:    rgba(212, 160, 23, 0.28);
     --t4-cyan:            #2c7a6e;
     --t4-cyan-dim:        rgba(44, 122, 110, 0.08);
     --t4-cyan-border:     rgba(44, 122, 110, 0.22);
     --t4-blue:            #3a6b4b;
     --t4-blue-dim:        rgba(58, 107, 75, 0.08);
     --t4-blue-border:     rgba(58, 107, 75, 0.22);
     --t4-green-dim:       rgba(44, 95, 45, 0.06);
     --t4-green-border:    rgba(44, 95, 45, 0.20);
   
     --t4-batch:           #d4a017;
     --t4-cstr:            #c45c2c;
     --t4-pfr:             #3a6b4b;
     --t4-pbr:             #2c5f2d;
   
     --t4-border:          #cbd5c5;
     --t4-border-light:    #dee4da;
     --t4-border-mid:      #b2bcac;
   
     --t4-text:            #1a2e1a;
     --t4-text-muted:      #2a3e2a;
     --t4-text-mid:        #3a5238;
     --t4-text-dim:        #5a6e58;
     --t4-text-sub:        #7a8e78;
   
     --t4-font-mono:   'DM Mono', 'JetBrains Mono', monospace;
     --t4-font-ui:     'DM Sans', 'Segoe UI', system-ui, sans-serif;
     --t4-font-brand:  'Syne', sans-serif;
     --t4-font-serif:  'Source Serif 4', Georgia, serif;
   
     --t4-space-xs:  6px;
     --t4-space-sm:  10px;
     --t4-space-md:  16px;
     --t4-space-lg:  24px;
     --t4-space-xl:  40px;
     --t4-space-2xl: 56px;
   
     --t4-radius-sm: 5px;
     --t4-radius-md: 9px;
     --t4-radius-lg: 13px;
   
     --t4-sidebar-w: 260px;
   }
   
   /* ─── Reset ─────────────────────────────────────────────────── */
   *,
   *::before,
   *::after {
     box-sizing: border-box;
     margin: 0;
     padding: 0;
   }
   
   /* ─── Scrollbar ─────────────────────────────────────────────── */
   ::-webkit-scrollbar        { width: 5px; height: 5px; }
   ::-webkit-scrollbar-track  { background: transparent; }
   ::-webkit-scrollbar-thumb  { background: var(--t4-border); border-radius: 3px; }
   ::-webkit-scrollbar-thumb:hover { background: var(--t4-border-mid); }
   
   /* ══════════════════════════════════════════════════════════════
      CONTAINER
   ══════════════════════════════════════════════════════════════ */
   .cre4-container {
     font-family: var(--t4-font-ui);
     background:  var(--t4-bg);
     color:       var(--t4-text);
     display:     flex;
     height:      100%;
     width:       100%;
     font-size:   15px;
     line-height: 1.7;
     overflow:    hidden;
   }
   
   /* ══════════════════════════════════════════════════════════════
      SIDEBAR
   ══════════════════════════════════════════════════════════════ */
   .cre4-sidebar {
     display:        none;
     width:          var(--t4-sidebar-w);
     min-width:      var(--t4-sidebar-w);
     background:     var(--t4-sidebar-bg);
     border-right:   1px solid var(--t4-border);
     height:         100%;
     overflow-y:     auto;
     padding-bottom: 40px;
     font-size:      13px;
     flex-shrink:    0;
   }
   
   @media (min-width: 1600px) {
     .cre4-sidebar { display: block; }
   }
   
   .cre4-sidebar-header {
     background:    var(--t4-sidebar-header);
     padding:       20px 18px 16px;
     border-bottom: 1px solid var(--t4-border);
     position:      sticky;
     top:           0;
     z-index:       10;
   }
   
   .cre4-sidebar-header h1 {
     font-family:    var(--t4-font-mono);
     font-size:      11px;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t4-accent);
     margin-bottom:  4px;
     font-weight:    500;
   }
   
   .cre4-sidebar-header p {
     font-size: 12px;
     color:     var(--t4-text-muted);
   }
   
   .cre4-nav-section {
     padding:        14px 0 4px 18px;
     font-family:    var(--t4-font-mono);
     font-size:      10px;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t4-amber);
     margin-top:     8px;
     font-weight:    500;
   }
   
   .cre4-nav-item {
     display:      block;
     padding:      7px 18px 7px 28px;
     color:        var(--t4-text-muted);
     text-decoration: none;
     border-left:  3px solid transparent;
     transition:   all 0.15s;
     line-height:  1.4;
     cursor:       pointer;
   }
   .cre4-nav-item:hover {
     color:             var(--t4-text);
     background:        var(--t4-accent-dim);
     border-left-color: var(--t4-accent);
   }
   .cre4-nav-item--sub {
     padding-left: 40px;
     font-size:    12px;
     color:        var(--t4-text-dim);
   }
   
   /* ══════════════════════════════════════════════════════════════
      MAIN CONTENT
   ══════════════════════════════════════════════════════════════ */
   .cre4-main {
     flex:       1 1;
     overflow-y: auto;
     overflow-x: hidden;
     min-width:  0;
     animation:  fadeIn4 0.3s ease;
   }
   
   .cre4-main-inner {
     margin:  0 auto;
     padding: 48px 56px 80px;
   }
   
   /* ─── Hero ──────────────────────────────────────────────────── */
   .cre4-hero {
     margin-bottom:  var(--t4-space-2xl);
     padding-bottom: 32px;
     border-bottom:  1px solid var(--t4-border-light);
   }
   
   .cre4-hero-tag {
     font-family:    var(--t4-font-mono);
     font-size:      11px;
     text-transform: uppercase;
     letter-spacing: 3px;
     color:          var(--t4-amber);
     margin-bottom:  12px;
   }
   
   .cre4-hero h1 {
     font-family:   var(--t4-font-serif);
     font-size:     38px;
     font-weight:   700;
     line-height:   1.2;
     margin-bottom: 12px;
     color:         var(--t4-text);
   }
   
   .cre4-hero-desc {
     color:     var(--t4-text-muted);
     font-size: 16px;
     max-width: 620px;
     line-height: 1.6;
   }
   
   .cre4-hero-meta {
     display:    flex;
     gap:        24px;
     margin-top: 20px;
     flex-wrap:  wrap;
   }
   
   .cre4-meta-item {
     font-family: var(--t4-font-mono);
     font-size:   11px;
     color:       var(--t4-text-dim);
     display:     flex;
     align-items: center;
     gap:         6px;
   }
   
   .cre4-meta-dot {
     width:         6px;
     height:        6px;
     border-radius: 50%;
     background:    var(--t4-accent);
     display:       inline-block;
   }
   
   /* ─── TOC box ───────────────────────────────────────────────── */
   .cre4-toc-box {
     background:    var(--t4-surface);
     border:        1px solid var(--t4-border-light);
     border-top:    3px solid var(--t4-blue);
     border-radius: var(--t4-radius-lg);
     padding:       22px 26px;
     margin-bottom: var(--t4-space-2xl);
   }
   
   .cre4-toc-box h3 {
     font-family:    var(--t4-font-mono);
     font-size:      11px;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t4-text-dim);
     margin-bottom:  14px;
     font-weight:    500;
   }
   
   .cre4-toc-grid {
     display:               grid;
     grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
     gap:                   6px 20px;
   }
   
   .cre4-toc-link {
     font-size:       13px;
     color:           var(--t4-blue);
     text-decoration: none;
     padding:         4px 0;
     transition:      color 0.15s;
   }
   .cre4-toc-link:hover { color: var(--t4-accent); text-decoration: underline; }
   
   /* ══════════════════════════════════════════════════════════════
      DIAGRAM STYLES
   ══════════════════════════════════════════════════════════════ */
   
   /* ─── Two Steps Diagram ─────────────────────────────────────── */
   .cre4-two-steps-container {
     background: var(--t4-surface);
     border-radius: var(--t4-radius-lg);
     padding: 24px;
     margin: 24px 0;
     border: 1px solid var(--t4-border-light);
   }
   
   .cre4-two-steps-diagram {
     display: flex;
     align-items: center;
     justify-content: space-between;
     gap: 16px;
     flex-wrap: wrap;
   }
   
   .cre4-step-box {
     flex: 1 1;
     min-width: 180px;
     padding: 20px;
     border-radius: var(--t4-radius-md);
     text-align: center;
   }
   
   .cre4-step-box--rate {
     background: var(--t4-cyan-dim);
     border: 2px solid var(--t4-cyan);
   }
   
   .cre4-step-box--stoich {
     background: var(--t4-blue-dim);
     border: 2px solid var(--t4-blue);
   }
   
   .cre4-step-box--combine {
     background: var(--t4-accent-dim);
     border: 2px solid var(--t4-accent);
   }
   
   .cre4-step-box-title {
     font-family: var(--t4-font-mono);
     font-size: 12px;
     font-weight: 600;
     margin-bottom: 12px;
   }
   
   .cre4-step-box--rate .cre4-step-box-title { color: var(--t4-cyan); }
   .cre4-step-box--stoich .cre4-step-box-title { color: var(--t4-blue); }
   .cre4-step-box--combine .cre4-step-box-title { color: var(--t4-accent); }
   
   .cre4-step-box-eq {
     font-family: var(--t4-font-mono);
     font-size: 14px;
     margin: 12px 0;
     padding: 8px;
     background: rgba(255,255,255,0.5);
     border-radius: var(--t4-radius-sm);
   }
   
   .cre4-step-box-desc {
     font-size: 12px;
     color: var(--t4-text-dim);
   }
   
   .cre4-step-arrow {
     font-size: 28px;
     color: var(--t4-text-mid);
     font-weight: bold;
   }
   
   @media (max-width: 700px) {
     .cre4-two-steps-diagram { flex-direction: column; }
     .cre4-step-arrow { transform: rotate(90deg); }
   }
   
   /* ─── Reactors Diagram ──────────────────────────────────────── */
   .cre4-reactors-diagram {
     display: flex;
     justify-content: center;
     gap: 32px;
     margin: 24px 0;
     padding: 20px;
     background: var(--t4-surface);
     border-radius: var(--t4-radius-lg);
     border: 1px solid var(--t4-border-light);
   }
   
   .cre4-reactor-icon {
     text-align: center;
   }
   
   .cre4-reactor-icon svg {
     display: block;
     margin: 0 auto;
   }
   
   /* ─── Arrhenius Plot ────────────────────────────────────────── */
   .cre4-arrhenius-container {
     background: var(--t4-surface);
     border-radius: var(--t4-radius-lg);
     padding: 24px;
     margin: 24px 0;
     border: 1px solid var(--t4-border-light);
   }
   
   .cre4-arrhenius-title {
     font-family: var(--t4-font-mono);
     font-size: 11px;
     text-transform: uppercase;
     letter-spacing: 2px;
     color: var(--t4-text-dim);
     margin-bottom: 16px;
   }
   
   .cre4-arrhenius-svg {
     width: 100%;
     max-width: 500px;
     display: block;
     margin: 0 auto;
   }
   
   .cre4-arrhenius-caption {
     font-size: 12px;
     color: var(--t4-text-sub);
     text-align: center;
     margin-top: 14px;
     font-style: italic;
   }
   
   /* ─── Stoichiometry Table Visual ─────────────────────────────── */
   .cre4-stoich-table-visual {
     background: var(--t4-surface);
     border-radius: var(--t4-radius-lg);
     border: 1px solid var(--t4-border);
     overflow: hidden;
     margin: 24px 0;
   }
   
   .cre4-stoich-row {
     display: grid;
     grid-template-columns: 80px 1fr 1fr 1.5fr;
     border-bottom: 1px solid var(--t4-border-light);
   }
   
   .cre4-stoich-row > span {
     padding: 12px 16px;
     font-size: 13px;
   }
   
   .cre4-stoich-header {
     background: var(--t4-panel);
     font-family: var(--t4-font-mono);
     font-size: 10px;
     text-transform: uppercase;
     letter-spacing: 1px;
     font-weight: 600;
     color: var(--t4-text-dim);
   }
   
   .cre4-stoich-header > span {
     padding: 10px 16px;
   }
   
   .cre4-stoich-species {
     font-family: var(--t4-font-mono);
     font-weight: 600;
     color: var(--t4-text-mid);
   }
   
   .cre4-stoich-result {
     font-family: var(--t4-font-mono);
     color: var(--t4-accent);
     font-weight: 500;
   }
   
   .cre4-stoich-total {
     background: var(--t4-accent-dim);
     border-top: 1px solid var(--t4-border);
   }
   
   .cre4-stoich-equilibrium .cre4-stoich-total {
     background: var(--t4-amber-dim);
   }
   
   @media (max-width: 800px) {
     .cre4-stoich-row {
       grid-template-columns: 60px 1fr 1fr 1fr;
       font-size: 11px;
     }
     .cre4-stoich-row > span { padding: 8px 12px; }
   }
   
   /* ─── Algorithm Tower Diagram ───────────────────────────────── */
   .cre4-algorithm-tower {
     background: var(--t4-surface);
     border-radius: var(--t4-radius-lg);
     padding: 24px;
     margin: 24px 0;
     border: 1px solid var(--t4-border-light);
     display: flex;
     flex-direction: column;
     align-items: center;
     gap: 8px;
   }
   
   .cre4-tower-block {
     display: flex;
     align-items: center;
     gap: 20px;
     width: 100%;
     max-width: 500px;
     padding: 16px 20px;
     border-radius: var(--t4-radius-md);
     transition: transform 0.2s;
   }
   
   .cre4-tower-block:hover {
     transform: translateX(8px);
   }
   
   .cre4-tower-block--1 { background: rgba(212,160,23,0.10); border-left: 4px solid var(--t4-amber); }
   .cre4-tower-block--2 { background: rgba(44,122,110,0.08); border-left: 4px solid var(--t4-cyan); }
   .cre4-tower-block--3 { background: rgba(58,107,75,0.08); border-left: 4px solid var(--t4-blue); }
   .cre4-tower-block--4 { background: rgba(44,95,45,0.08); border-left: 4px solid var(--t4-accent); }
   
   .cre4-tower-step {
     width: 40px;
     height: 40px;
     background: var(--t4-accent);
     color: white;
     border-radius: 50%;
     display: flex;
     align-items: center;
     justify-content: center;
     font-family: var(--t4-font-mono);
     font-weight: bold;
     font-size: 18px;
     flex-shrink: 0;
   }
   
   .cre4-tower-block--1 .cre4-tower-step { background: var(--t4-amber); }
   .cre4-tower-block--2 .cre4-tower-step { background: var(--t4-cyan); }
   .cre4-tower-block--3 .cre4-tower-step { background: var(--t4-blue); }
   
   .cre4-tower-content {
     flex: 1 1;
   }
   
   .cre4-tower-content h4 {
     font-size: 15px;
     font-weight: 600;
     color: var(--t4-text-mid);
     margin-bottom: 4px;
   }
   
   .cre4-tower-content p {
     font-size: 12px;
     color: var(--t4-text-dim);
     margin: 0;
   }
   
   .cre4-tower-equation {
     margin-top: 8px;
     font-family: var(--t4-font-mono);
     font-size: 11px;
     color: var(--t4-blue);
   }
   
   .cre4-tower-arrow {
     font-size: 20px;
     color: var(--t4-text-mid);
   }
   
   /* ══════════════════════════════════════════════════════════════
      EXISTING STYLES (from previous version)
   ══════════════════════════════════════════════════════════════ */
   
   /* ─── Lecture badge ─────────────────────────────────────────── */
   .cre4-lec-badge {
     display:        inline-block;
     font-family:    var(--t4-font-mono);
     font-size:      10px;
     text-transform: uppercase;
     letter-spacing: 2px;
     padding:        3px 9px;
     border-radius:  var(--t4-radius-sm);
     margin-bottom:  10px;
     font-weight:    500;
   }
   
   .cre4-lec-badge--block1 {
     background: rgba(212, 160, 23, 0.10);
     color:      var(--t4-amber);
     border:     1px solid var(--t4-amber-border);
   }
   .cre4-lec-badge--block2 {
     background: var(--t4-cyan-dim);
     color:      var(--t4-cyan);
     border:     1px solid var(--t4-cyan-border);
   }
   .cre4-lec-badge--block3 {
     background: var(--t4-blue-dim);
     color:      var(--t4-blue);
     border:     1px solid var(--t4-blue-border);
   }
   
   /* ─── Section ───────────────────────────────────────────────── */
   .cre4-section {
     margin-bottom: var(--t4-space-2xl);
     scroll-margin-top: 24px;
   }
   
   .cre4-section-label {
     font-family:    var(--t4-font-mono);
     font-size:      10px;
     text-transform: uppercase;
     letter-spacing: 2.5px;
     color:          var(--t4-text-sub);
     margin-bottom:  6px;
   }
   
   .cre4-section h2 {
     font-family:   var(--t4-font-serif);
     font-size:     26px;
     font-weight:   700;
     color:         var(--t4-text);
     margin-bottom: 6px;
     line-height:   1.3;
   }
   
   .cre4-section-divider {
     width:         40px;
     height:        3px;
     background:    var(--t4-accent);
     margin-bottom: 22px;
     border-radius: 2px;
   }
   
   .cre4-section p {
     margin-bottom: 14px;
     color:         var(--t4-text-muted);
     line-height:   1.75;
   }
   
   /* ─── Equation box ──────────────────────────────────────────── */
   .cre4-eq-box {
     background:    var(--t4-eq-bg);
     border:        1px solid var(--t4-border-light);
     border-left:   3px solid var(--t4-amber);
     border-radius: var(--t4-radius-md);
     padding:       18px 22px;
     margin:        18px 0;
     overflow-x:    auto;
   }
   
   .cre4-eq-label {
     font-size:      10px;
     font-family:    var(--t4-font-mono);
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t4-text-dim);
     margin-bottom:  8px;
   }
   
   .cre4-eq-main {
     font-family: var(--t4-font-mono);
     font-size:   14px;
     color:       var(--t4-blue);
     line-height: 2;
   }
   
   .cre4-eq-note {
     font-size:   12px;
     color:       var(--t4-text-dim);
     margin-top:  8px;
     white-space: pre-line;
     line-height: 1.6;
   }
   
   /* ─── Callout boxes ─────────────────────────────────────────── */
   .cre4-callout {
     border-radius: var(--t4-radius-md);
     padding:       14px 18px;
     margin:        18px 0;
     font-size:     14px;
     line-height:   1.65;
   }
   .cre4-callout p  { color: var(--t4-text-muted); margin: 0; }
   .cre4-callout--key  { background: var(--t4-blue-dim);  border: 1px solid var(--t4-blue-border);  }
   .cre4-callout--warn { background: var(--t4-amber-dim); border: 1px solid var(--t4-amber-border); }
   .cre4-callout--tip  { background: var(--t4-green-dim); border: 1px solid var(--t4-green-border); }
   .cre4-callout--info { background: var(--t4-cyan-dim);  border: 1px solid var(--t4-cyan-border);  }
   
   /* ─── Card grid ─────────────────────────────────────────────── */
   .cre4-card-grid {
     display:               grid;
     grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
     gap:                   14px;
     margin:                20px 0;
   }
   
   .cre4-card {
     background:    var(--t4-surface);
     border:        1px solid var(--t4-border-light);
     border-radius: var(--t4-radius-md);
     padding:       16px 18px;
     transition:    border-color 0.18s, box-shadow 0.18s;
     box-shadow:    0 1px 4px rgba(0,0,0,0.04);
   }
   .cre4-card:hover {
     border-color: var(--t4-accent);
     box-shadow:   0 4px 14px var(--t4-accent-glow);
   }
   .cre4-card-icon  { font-size: 22px; margin-bottom: 8px; }
   .cre4-card h4    { font-size: 14px; font-weight: 600; color: var(--t4-text-mid); margin-bottom: 6px; }
   .cre4-card p     { font-size: 13px; color: var(--t4-text-muted); margin: 0; line-height: 1.5; }
   
   /* ─── Steps list ────────────────────────────────────────────── */
   .cre4-steps { margin: 20px 0; }
   
   .cre4-step {
     display:       flex;
     gap:           16px;
     margin-bottom: 20px;
     align-items:   flex-start;
   }
   
   .cre4-step-num {
     min-width:       32px;
     height:          32px;
     background:      var(--t4-accent);
     color:           #fff;
     border-radius:   50%;
     display:         flex;
     align-items:     center;
     justify-content: center;
     font-family:     var(--t4-font-mono);
     font-weight:     600;
     font-size:       13px;
     flex-shrink:     0;
     box-shadow:      0 2px 8px var(--t4-accent-glow);
   }
   .cre4-step-content { flex: 1 1; }
   .cre4-step-content h4 { font-size: 14px; font-weight: 600; color: var(--t4-text-mid); margin-bottom: 6px; }
   
   /* ─── Tables ────────────────────────────────────────────────── */
   .cre4-table {
     width:           100%;
     border-collapse: collapse;
     margin:          20px 0;
     font-size:       13px;
     background:      var(--t4-surface);
     border-radius:   var(--t4-radius-md);
     overflow:        hidden;
     border:          1px solid var(--t4-border-light);
   }
   .cre4-table thead { background: var(--t4-panel); }
   .cre4-table th    { padding: 10px 14px; text-align: left; font-family: var(--t4-font-mono); font-size: 10px; text-transform: uppercase; letter-spacing: 1.5px; color: var(--t4-text-muted); border-bottom: 1px solid var(--t4-border); font-weight: 500; }
   .cre4-table td    { padding: 10px 14px; border-bottom: 1px solid var(--t4-border-light); color: var(--t4-text-muted); vertical-align: middle; }
   .cre4-table tr:last-child td { border-bottom: none; }
   
   /* ─── Reactor type badges ───────────────────────────────────── */
   .cre4-badge {
     display:        inline-block;
     font-family:    var(--t4-font-mono);
     font-size:      10px;
     text-transform: uppercase;
     letter-spacing: 1.5px;
     padding:        3px 8px;
     border-radius:  var(--t4-radius-sm);
     font-weight:    600;
     white-space:    nowrap;
   }
   .cre4-badge--batch { background: rgba(212,160,23,0.12); color: var(--t4-batch); border: 1px solid rgba(212,160,23,0.25); }
   .cre4-badge--cstr  { background: rgba(196,92,44,0.12);  color: var(--t4-cstr);  border: 1px solid rgba(196,92,44,0.25); }
   .cre4-badge--pfr   { background: var(--t4-blue-dim);    color: var(--t4-pfr);   border: 1px solid var(--t4-blue-border); }
   .cre4-badge--pbr   { background: var(--t4-green-dim);   color: var(--t4-pbr);   border: 1px solid var(--t4-green-border); }
   
   /* ─── Reactor block ─────────────────────────────────────────── */
   .cre4-reactor-block {
     border-radius: var(--t4-radius-md);
     overflow:      hidden;
     margin:        20px 0;
     border:        1px solid var(--t4-border-light);
     box-shadow:    0 1px 6px rgba(0,0,0,0.05);
   }
   
   .cre4-reactor-block-header {
     padding:     10px 18px;
     font-family: var(--t4-font-mono);
     font-size:   11px;
     text-transform: uppercase;
     letter-spacing: 2px;
     font-weight: 600;
   }
   .cre4-reactor-block-body {
     padding: 18px 20px;
     background: var(--t4-surface);
   }
   
   .cre4-reactor-block--batch .cre4-reactor-block-header {
     background:    rgba(212,160,23,0.10);
     color:         var(--t4-batch);
     border-bottom: 1px solid rgba(212,160,23,0.18);
   }
   .cre4-reactor-block--cstr .cre4-reactor-block-header {
     background:    rgba(196,92,44,0.10);
     color:         var(--t4-cstr);
     border-bottom: 1px solid rgba(196,92,44,0.18);
   }
   .cre4-reactor-block--pfr .cre4-reactor-block-header {
     background:    var(--t4-blue-dim);
     color:         var(--t4-pfr);
     border-bottom: 1px solid var(--t4-blue-border);
   }
   .cre4-reactor-block--pbr .cre4-reactor-block-header {
     background:    var(--t4-green-dim);
     color:         var(--t4-pbr);
     border-bottom: 1px solid var(--t4-green-border);
   }
   
   /* ─── Footer ────────────────────────────────────────────────── */
   .cre4-footer {
     border-top:  1px solid var(--t4-border-light);
     padding-top: 24px;
     margin-top:  40px;
     color:       var(--t4-text-dim);
     font-family: var(--t4-font-mono);
     font-size:   11px;
   }
   
   /* ─── Animation ─────────────────────────────────────────────── */
   @keyframes fadeIn4 {
     from { opacity: 0; transform: translateY(4px); }
     to   { opacity: 1; transform: translateY(0); }
   }
   
   /* ─── Katex overrides ───────────────────────────────────────── */
   .katex { font-size: 1.05em; }
   .katex-display { margin: 0.8em 0; overflow-x: auto; overflow-y: hidden; }
   
   /* ─── Responsive ────────────────────────────────────────────── */
   @media (max-width: 1200px) {
     .cre4-main-inner { padding: 36px 36px 60px; }
   }
   
   @media (max-width: 900px) {
     .cre4-sidebar { display: none !important; }
     .cre4-main-inner { padding: 24px 20px 60px; }
     .cre4-toc-grid { grid-template-columns: 1fr 1fr; }
   }
   
   @media (max-width: 600px) {
     .cre4-card-grid { grid-template-columns: 1fr; }
     .cre4-hero h1 { font-size: 26px; }
     .cre4-toc-grid { grid-template-columns: 1fr; }
     .cre4-step { flex-direction: column; gap: 8px; }
   }
   /* ══════════════════════════════════════════════════════════════
      REACTORS IN SERIES DIAGRAM
   ══════════════════════════════════════════════════════════════ */
   
   .cre4-series-diagram-container {
     background: var(--t4-surface);
     border-radius: var(--t4-radius-lg);
     padding: 24px;
     margin: 24px 0;
     border: 1px solid var(--t4-border-light);
     box-shadow: 0 2px 10px rgba(0,0,0,0.04);
   }
   
   .cre4-series-title {
     font-family: var(--t4-font-mono);
     font-size: 11px;
     text-transform: uppercase;
     letter-spacing: 2px;
     color: var(--t4-text-dim);
     margin-bottom: 20px;
     text-align: center;
   }
   
   .cre4-series-diagram {
     display: flex;
     align-items: center;
     justify-content: center;
     gap: 20px;
     flex-wrap: wrap;
     margin-bottom: 20px;
   }
   
   .cre4-series-reactor {
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     width: 120px;
     height: 100px;
     border-radius: var(--t4-radius-md);
     border: 2px solid;
     padding: 12px;
     text-align: center;
     transition: transform 0.2s ease, box-shadow 0.2s ease;
   }
   
   .cre4-series-reactor:hover {
     transform: translateY(-4px);
     box-shadow: 0 6px 16px rgba(0,0,0,0.1);
   }
   
   .cre4-series-reactor--cstr {
     background: rgba(196, 92, 44, 0.08);
     border-color: var(--t4-cstr);
   }
   
   .cre4-series-reactor--pfr {
     background: rgba(58, 107, 75, 0.08);
     border-color: var(--t4-pfr);
     border-radius: 60px;
   }
   
   .cre4-series-reactor-label {
     font-family: var(--t4-font-mono);
     font-size: 11px;
     text-transform: uppercase;
     letter-spacing: 2px;
     font-weight: 600;
   }
   
   .cre4-series-reactor--cstr .cre4-series-reactor-label {
     color: var(--t4-cstr);
   }
   
   .cre4-series-reactor--pfr .cre4-series-reactor-label {
     color: var(--t4-pfr);
   }
   
   .cre4-series-reactor-vol {
     font-family: var(--t4-font-mono);
     font-size: 18px;
     font-weight: 700;
     color: var(--t4-text-mid);
     margin: 6px 0;
   }
   
   .cre4-series-reactor-x {
     font-family: var(--t4-font-mono);
     font-size: 12px;
     color: var(--t4-accent);
     background: var(--t4-accent-dim);
     padding: 2px 8px;
     border-radius: 20px;
   }
   
   .cre4-series-arrow {
     font-size: 28px;
     color: var(--t4-text-mid);
     font-weight: bold;
   }
   
   .cre4-series-note {
     text-align: center;
     margin-top: 16px;
     padding-top: 12px;
     border-top: 1px dashed var(--t4-border-light);
   }
   
   .cre4-series-warning {
     font-family: var(--t4-font-mono);
     font-size: 11px;
     color: var(--t4-amber);
     background: var(--t4-amber-dim);
     padding: 6px 12px;
     border-radius: 20px;
     display: inline-block;
   }
   
   /* Responsive adjustments for series diagram */
   @media (max-width: 600px) {
     .cre4-series-diagram {
       flex-direction: column;
       gap: 12px;
     }
     
     .cre4-series-arrow {
       transform: rotate(90deg);
     }
     
     .cre4-series-reactor {
       width: 140px;
     }
   }`, "",{"version":3,"sources":["webpack://./src/styles/Tutorial4.css"],"names":[],"mappings":"AAAA;iEACiE;;GAI9D,kEAAkE;GAClE;KACE,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,6BAA6B;KAC7B,4CAA4C;KAC5C,4CAA4C;KAC5C,6BAA6B;;KAE7B,6BAA6B;KAC7B,8CAA8C;KAC9C,8CAA8C;KAC9C,6BAA6B;KAC7B,8CAA8C;KAC9C,8CAA8C;KAC9C,6BAA6B;KAC7B,6CAA6C;KAC7C,6CAA6C;KAC7C,4CAA4C;KAC5C,4CAA4C;;KAE5C,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;KAC7B,6BAA6B;;KAE7B,wDAAwD;KACxD,8DAA8D;KAC9D,oCAAoC;KACpC,kDAAkD;;KAElD,mBAAmB;KACnB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;;KAEpB,mBAAmB;KACnB,mBAAmB;KACnB,oBAAoB;;KAEpB,qBAAqB;GACvB;;GAEA,kEAAkE;GAClE;;;KAGE,sBAAsB;KACtB,SAAS;KACT,UAAU;GACZ;;GAEA,kEAAkE;GAClE,6BAA6B,UAAU,EAAE,WAAW,EAAE;GACtD,6BAA6B,uBAAuB,EAAE;GACtD,6BAA6B,4BAA4B,EAAE,kBAAkB,EAAE;GAC/E,kCAAkC,gCAAgC,EAAE;;GAEpE;;mEAEgE;GAChE;KACE,8BAA8B;KAC9B,yBAAyB;KACzB,2BAA2B;KAC3B,iBAAiB;KACjB,iBAAiB;KACjB,iBAAiB;KACjB,iBAAiB;KACjB,gBAAgB;KAChB,mBAAmB;GACrB;;GAEA;;mEAEgE;GAChE;KACE,oBAAoB;KACpB,mCAAmC;KACnC,mCAAmC;KACnC,oCAAoC;KACpC,0CAA0C;KAC1C,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,oBAAoB;KACpB,iBAAiB;GACnB;;GAEA;KACE,gBAAgB,cAAc,EAAE;GAClC;;GAEA;KACE,uCAAuC;KACvC,6BAA6B;KAC7B,yCAAyC;KACzC,qBAAqB;KACrB,gBAAgB;KAChB,iBAAiB;GACnB;;GAEA;KACE,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,gCAAgC;KAChC,mBAAmB;KACnB,mBAAmB;GACrB;;GAEA;KACE,eAAe;KACf,+BAA+B;GACjC;;GAEA;KACE,+BAA+B;KAC/B,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,+BAA+B;KAC/B,mBAAmB;KACnB,mBAAmB;GACrB;;GAEA;KACE,mBAAmB;KACnB,+BAA+B;KAC/B,kCAAkC;KAClC,qBAAqB;KACrB,mCAAmC;KACnC,uBAAuB;KACvB,iBAAiB;KACjB,qBAAqB;GACvB;GACA;KACE,iCAAiC;KACjC,uCAAuC;KACvC,mCAAmC;GACrC;GACA;KACE,kBAAkB;KAClB,kBAAkB;KAClB,gCAAgC;GAClC;;GAEA;;mEAEgE;GAChE;KACE,eAAa;KACb,gBAAgB;KAChB,kBAAkB;KAClB,aAAa;KACb,6BAA6B;GAC/B;;GAEA;KACE,eAAe;KACf,uBAAuB;GACzB;;GAEA,kEAAkE;GAClE;KACE,mCAAmC;KACnC,oBAAoB;KACpB,gDAAgD;GAClD;;GAEA;KACE,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,+BAA+B;KAC/B,oBAAoB;GACtB;;GAEA;KACE,mCAAmC;KACnC,mBAAmB;KACnB,kBAAkB;KAClB,kBAAkB;KAClB,mBAAmB;KACnB,6BAA6B;GAC/B;;GAEA;KACE,+BAA+B;KAC/B,eAAe;KACf,gBAAgB;KAChB,gBAAgB;GAClB;;GAEA;KACE,gBAAgB;KAChB,gBAAgB;KAChB,gBAAgB;KAChB,gBAAgB;GAClB;;GAEA;KACE,gCAAgC;KAChC,iBAAiB;KACjB,+BAA+B;KAC/B,iBAAiB;KACjB,mBAAmB;KACnB,gBAAgB;GAClB;;GAEA;KACE,kBAAkB;KAClB,kBAAkB;KAClB,kBAAkB;KAClB,+BAA+B;KAC/B,2BAA2B;GAC7B;;GAEA,kEAAkE;GAClE;KACE,gCAAgC;KAChC,+CAA+C;KAC/C,uCAAuC;KACvC,kCAAkC;KAClC,wBAAwB;KACxB,kCAAkC;GACpC;;GAEA;KACE,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,kCAAkC;KAClC,oBAAoB;KACpB,mBAAmB;GACrB;;GAEA;KACE,2BAA2B;KAC3B,4DAA4D;KAC5D,+BAA+B;GACjC;;GAEA;KACE,qBAAqB;KACrB,+BAA+B;KAC/B,qBAAqB;KACrB,sBAAsB;KACtB,4BAA4B;GAC9B;GACA,uBAAuB,uBAAuB,EAAE,0BAA0B,EAAE;;GAE5E;;mEAEgE;;GAEhE,kEAAkE;GAClE;KACE,6BAA6B;KAC7B,kCAAkC;KAClC,aAAa;KACb,cAAc;KACd,wCAAwC;GAC1C;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,SAAS;KACT,eAAe;GACjB;;GAEA;KACE,SAAO;KACP,gBAAgB;KAChB,aAAa;KACb,kCAAkC;KAClC,kBAAkB;GACpB;;GAEA;KACE,8BAA8B;KAC9B,gCAAgC;GAClC;;GAEA;KACE,8BAA8B;KAC9B,gCAAgC;GAClC;;GAEA;KACE,gCAAgC;KAChC,kCAAkC;GACpC;;GAEA;KACE,gCAAgC;KAChC,eAAe;KACf,gBAAgB;KAChB,mBAAmB;GACrB;;GAEA,4CAA4C,qBAAqB,EAAE;GACnE,8CAA8C,qBAAqB,EAAE;GACrE,+CAA+C,uBAAuB,EAAE;;GAExE;KACE,gCAAgC;KAChC,eAAe;KACf,cAAc;KACd,YAAY;KACZ,iCAAiC;KACjC,kCAAkC;GACpC;;GAEA;KACE,eAAe;KACf,yBAAyB;GAC3B;;GAEA;KACE,eAAe;KACf,yBAAyB;KACzB,iBAAiB;GACnB;;GAEA;KACE,0BAA0B,sBAAsB,EAAE;KAClD,mBAAmB,wBAAwB,EAAE;GAC/C;;GAEA,kEAAkE;GAClE;KACE,aAAa;KACb,uBAAuB;KACvB,SAAS;KACT,cAAc;KACd,aAAa;KACb,6BAA6B;KAC7B,kCAAkC;KAClC,wCAAwC;GAC1C;;GAEA;KACE,kBAAkB;GACpB;;GAEA;KACE,cAAc;KACd,cAAc;GAChB;;GAEA,kEAAkE;GAClE;KACE,6BAA6B;KAC7B,kCAAkC;KAClC,aAAa;KACb,cAAc;KACd,wCAAwC;GAC1C;;GAEA;KACE,gCAAgC;KAChC,eAAe;KACf,yBAAyB;KACzB,mBAAmB;KACnB,yBAAyB;KACzB,mBAAmB;GACrB;;GAEA;KACE,WAAW;KACX,gBAAgB;KAChB,cAAc;KACd,cAAc;GAChB;;GAEA;KACE,eAAe;KACf,yBAAyB;KACzB,kBAAkB;KAClB,gBAAgB;KAChB,kBAAkB;GACpB;;GAEA,mEAAmE;GACnE;KACE,6BAA6B;KAC7B,kCAAkC;KAClC,kCAAkC;KAClC,gBAAgB;KAChB,cAAc;GAChB;;GAEA;KACE,aAAa;KACb,yCAAyC;KACzC,+CAA+C;GACjD;;GAEA;KACE,kBAAkB;KAClB,eAAe;GACjB;;GAEA;KACE,2BAA2B;KAC3B,gCAAgC;KAChC,eAAe;KACf,yBAAyB;KACzB,mBAAmB;KACnB,gBAAgB;KAChB,yBAAyB;GAC3B;;GAEA;KACE,kBAAkB;GACpB;;GAEA;KACE,gCAAgC;KAChC,gBAAgB;KAChB,yBAAyB;GAC3B;;GAEA;KACE,gCAAgC;KAChC,uBAAuB;KACvB,gBAAgB;GAClB;;GAEA;KACE,gCAAgC;KAChC,sCAAsC;GACxC;;GAEA;KACE,+BAA+B;GACjC;;GAEA;KACE;OACE,uCAAuC;OACvC,eAAe;KACjB;KACA,0BAA0B,iBAAiB,EAAE;GAC/C;;GAEA,kEAAkE;GAClE;KACE,6BAA6B;KAC7B,kCAAkC;KAClC,aAAa;KACb,cAAc;KACd,wCAAwC;KACxC,aAAa;KACb,sBAAsB;KACtB,mBAAmB;KACnB,QAAQ;GACV;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,SAAS;KACT,WAAW;KACX,gBAAgB;KAChB,kBAAkB;KAClB,kCAAkC;KAClC,0BAA0B;GAC5B;;GAEA;KACE,0BAA0B;GAC5B;;GAEA,uBAAuB,iCAAiC,EAAE,sCAAsC,EAAE;GAClG,uBAAuB,iCAAiC,EAAE,qCAAqC,EAAE;GACjG,uBAAuB,gCAAgC,EAAE,qCAAqC,EAAE;GAChG,uBAAuB,+BAA+B,EAAE,uCAAuC,EAAE;;GAEjG;KACE,WAAW;KACX,YAAY;KACZ,4BAA4B;KAC5B,YAAY;KACZ,kBAAkB;KAClB,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,gCAAgC;KAChC,iBAAiB;KACjB,eAAe;KACf,cAAc;GAChB;;GAEA,wCAAwC,2BAA2B,EAAE;GACrE,wCAAwC,0BAA0B,EAAE;GACpE,wCAAwC,0BAA0B,EAAE;;GAEpE;KACE,SAAO;GACT;;GAEA;KACE,eAAe;KACf,gBAAgB;KAChB,yBAAyB;KACzB,kBAAkB;GACpB;;GAEA;KACE,eAAe;KACf,yBAAyB;KACzB,SAAS;GACX;;GAEA;KACE,eAAe;KACf,gCAAgC;KAChC,eAAe;KACf,qBAAqB;GACvB;;GAEA;KACE,eAAe;KACf,yBAAyB;GAC3B;;GAEA;;mEAEgE;;GAEhE,kEAAkE;GAClE;KACE,4BAA4B;KAC5B,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,mBAAmB;KACnB,uBAAuB;KACvB,mCAAmC;KACnC,oBAAoB;KACpB,mBAAmB;GACrB;;GAEA;KACE,oCAAoC;KACpC,2BAA2B;KAC3B,4CAA4C;GAC9C;GACA;KACE,8BAA8B;KAC9B,0BAA0B;KAC1B,2CAA2C;GAC7C;GACA;KACE,8BAA8B;KAC9B,0BAA0B;KAC1B,2CAA2C;GAC7C;;GAEA,kEAAkE;GAClE;KACE,kCAAkC;KAClC,uBAAuB;GACzB;;GAEA;KACE,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,qBAAqB;KACrB,kCAAkC;KAClC,mBAAmB;GACrB;;GAEA;KACE,mCAAmC;KACnC,mBAAmB;KACnB,kBAAkB;KAClB,6BAA6B;KAC7B,kBAAkB;KAClB,kBAAkB;GACpB;;GAEA;KACE,mBAAmB;KACnB,kBAAkB;KAClB,+BAA+B;KAC/B,mBAAmB;KACnB,kBAAkB;GACpB;;GAEA;KACE,mBAAmB;KACnB,mCAAmC;KACnC,mBAAmB;GACrB;;GAEA,kEAAkE;GAClE;KACE,8BAA8B;KAC9B,+CAA+C;KAC/C,wCAAwC;KACxC,kCAAkC;KAClC,wBAAwB;KACxB,qBAAqB;KACrB,mBAAmB;GACrB;;GAEA;KACE,oBAAoB;KACpB,mCAAmC;KACnC,yBAAyB;KACzB,mBAAmB;KACnB,kCAAkC;KAClC,mBAAmB;GACrB;;GAEA;KACE,gCAAgC;KAChC,iBAAiB;KACjB,2BAA2B;KAC3B,cAAc;GAChB;;GAEA;KACE,iBAAiB;KACjB,+BAA+B;KAC/B,gBAAgB;KAChB,qBAAqB;KACrB,gBAAgB;GAClB;;GAEA,kEAAkE;GAClE;KACE,kCAAkC;KAClC,wBAAwB;KACxB,qBAAqB;KACrB,mBAAmB;KACnB,mBAAmB;GACrB;GACA,mBAAmB,2BAA2B,EAAE,SAAS,EAAE;GAC3D,sBAAsB,8BAA8B,GAAG,uCAAuC,GAAG;GACjG,sBAAsB,+BAA+B,EAAE,wCAAwC,EAAE;GACjG,sBAAsB,+BAA+B,EAAE,wCAAwC,EAAE;GACjG,sBAAsB,8BAA8B,GAAG,uCAAuC,GAAG;;GAEjG,kEAAkE;GAClE;KACE,2BAA2B;KAC3B,4DAA4D;KAC5D,2BAA2B;KAC3B,6BAA6B;GAC/B;;GAEA;KACE,gCAAgC;KAChC,+CAA+C;KAC/C,kCAAkC;KAClC,wBAAwB;KACxB,mDAAmD;KACnD,yCAAyC;GAC3C;GACA;KACE,8BAA8B;KAC9B,8CAA8C;GAChD;GACA,mBAAmB,eAAe,EAAE,kBAAkB,EAAE;GACxD,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;GACrG,mBAAmB,eAAe,EAAE,2BAA2B,EAAE,SAAS,EAAE,gBAAgB,EAAE;;GAE9F,kEAAkE;GAClE,cAAc,cAAc,EAAE;;GAE9B;KACE,mBAAmB;KACnB,mBAAmB;KACnB,mBAAmB;KACnB,yBAAyB;GAC3B;;GAEA;KACE,qBAAqB;KACrB,qBAAqB;KACrB,iCAAiC;KACjC,qBAAqB;KACrB,oBAAoB;KACpB,qBAAqB;KACrB,uBAAuB;KACvB,uBAAuB;KACvB,oCAAoC;KACpC,oBAAoB;KACpB,qBAAqB;KACrB,kBAAkB;KAClB,gDAAgD;GAClD;GACA,qBAAqB,SAAO,EAAE;GAC9B,wBAAwB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;;GAE1G,kEAAkE;GAClE;KACE,qBAAqB;KACrB,yBAAyB;KACzB,uBAAuB;KACvB,qBAAqB;KACrB,kCAAkC;KAClC,oCAAoC;KACpC,uBAAuB;KACvB,iDAAiD;GACnD;GACA,oBAAoB,2BAA2B,EAAE;GACjD,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,gCAAgC,EAAE,eAAe,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,2BAA2B,EAAE,yCAAyC,EAAE,gBAAgB,EAAE;GACzP,oBAAoB,kBAAkB,EAAE,+CAA+C,EAAE,2BAA2B,EAAE,sBAAsB,EAAE;GAC9I,+BAA+B,mBAAmB,EAAE;;GAEpD,kEAAkE;GAClE;KACE,4BAA4B;KAC5B,mCAAmC;KACnC,oBAAoB;KACpB,yBAAyB;KACzB,qBAAqB;KACrB,uBAAuB;KACvB,mCAAmC;KACnC,mBAAmB;KACnB,sBAAsB;GACxB;GACA,qBAAqB,iCAAiC,EAAE,sBAAsB,EAAE,uCAAuC,EAAE;GACzH,qBAAqB,gCAAgC,GAAG,qBAAqB,GAAG,sCAAsC,EAAE;GACxH,qBAAqB,8BAA8B,KAAK,oBAAoB,IAAI,uCAAuC,EAAE;GACzH,qBAAqB,+BAA+B,IAAI,oBAAoB,IAAI,wCAAwC,EAAE;;GAE1H,kEAAkE;GAClE;KACE,kCAAkC;KAClC,qBAAqB;KACrB,qBAAqB;KACrB,+CAA+C;KAC/C,yCAAyC;GAC3C;;GAEA;KACE,sBAAsB;KACtB,gCAAgC;KAChC,iBAAiB;KACjB,yBAAyB;KACzB,mBAAmB;KACnB,gBAAgB;GAClB;GACA;KACE,kBAAkB;KAClB,6BAA6B;GAC/B;;GAEA;KACE,oCAAoC;KACpC,8BAA8B;KAC9B,8CAA8C;GAChD;GACA;KACE,mCAAmC;KACnC,6BAA6B;KAC7B,6CAA6C;GAC/C;GACA;KACE,iCAAiC;KACjC,4BAA4B;KAC5B,8CAA8C;GAChD;GACA;KACE,kCAAkC;KAClC,4BAA4B;KAC5B,+CAA+C;GACjD;;GAEA,kEAAkE;GAClE;KACE,6CAA6C;KAC7C,iBAAiB;KACjB,iBAAiB;KACjB,+BAA+B;KAC/B,gCAAgC;KAChC,iBAAiB;GACnB;;GAEA,kEAAkE;GAClE;KACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;KAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;GAC/C;;GAEA,kEAAkE;GAClE,SAAS,iBAAiB,EAAE;GAC5B,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;GAExE,kEAAkE;GAClE;KACE,mBAAmB,uBAAuB,EAAE;GAC9C;;GAEA;KACE,gBAAgB,wBAAwB,EAAE;KAC1C,mBAAmB,uBAAuB,EAAE;KAC5C,iBAAiB,8BAA8B,EAAE;GACnD;;GAEA;KACE,kBAAkB,0BAA0B,EAAE;KAC9C,gBAAgB,eAAe,EAAE;KACjC,iBAAiB,0BAA0B,EAAE;KAC7C,aAAa,sBAAsB,EAAE,QAAQ,EAAE;GACjD;GACA;;mEAEgE;;GAEhE;KACE,6BAA6B;KAC7B,kCAAkC;KAClC,aAAa;KACb,cAAc;KACd,wCAAwC;KACxC,uCAAuC;GACzC;;GAEA;KACE,gCAAgC;KAChC,eAAe;KACf,yBAAyB;KACzB,mBAAmB;KACnB,yBAAyB;KACzB,mBAAmB;KACnB,kBAAkB;GACpB;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,SAAS;KACT,eAAe;KACf,mBAAmB;GACrB;;GAEA;KACE,aAAa;KACb,sBAAsB;KACtB,mBAAmB;KACnB,uBAAuB;KACvB,YAAY;KACZ,aAAa;KACb,kCAAkC;KAClC,iBAAiB;KACjB,aAAa;KACb,kBAAkB;KAClB,qDAAqD;GACvD;;GAEA;KACE,2BAA2B;KAC3B,sCAAsC;GACxC;;GAEA;KACE,mCAAmC;KACnC,4BAA4B;GAC9B;;GAEA;KACE,mCAAmC;KACnC,2BAA2B;KAC3B,mBAAmB;GACrB;;GAEA;KACE,gCAAgC;KAChC,eAAe;KACf,yBAAyB;KACzB,mBAAmB;KACnB,gBAAgB;GAClB;;GAEA;KACE,qBAAqB;GACvB;;GAEA;KACE,oBAAoB;GACtB;;GAEA;KACE,gCAAgC;KAChC,eAAe;KACf,gBAAgB;KAChB,yBAAyB;KACzB,aAAa;GACf;;GAEA;KACE,gCAAgC;KAChC,eAAe;KACf,uBAAuB;KACvB,gCAAgC;KAChC,gBAAgB;KAChB,mBAAmB;GACrB;;GAEA;KACE,eAAe;KACf,yBAAyB;KACzB,iBAAiB;GACnB;;GAEA;KACE,kBAAkB;KAClB,gBAAgB;KAChB,iBAAiB;KACjB,6CAA6C;GAC/C;;GAEA;KACE,gCAAgC;KAChC,eAAe;KACf,sBAAsB;KACtB,+BAA+B;KAC/B,iBAAiB;KACjB,mBAAmB;KACnB,qBAAqB;GACvB;;GAEA,8CAA8C;GAC9C;KACE;OACE,sBAAsB;OACtB,SAAS;KACX;;KAEA;OACE,wBAAwB;KAC1B;;KAEA;OACE,YAAY;KACd;GACF","sourcesContent":["/* Tutorial4.css  —  Updated with Diagram Styles\n   ============================================================ */\n\n   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Syne:wght@400;700;800&family=DM+Mono:wght@400;500&family=Source+Serif+4:ital,wght@0,400;0,600;0,700;1,400&display=swap');\n\n   /* ─── Design tokens ─────────────────────────────────────────── */\n   :root {\n     --t4-bg:              #eef2f0;\n     --t4-surface:         #ffffff;\n     --t4-panel:           #f4f6f2;\n     --t4-card:            #ffffff;\n     --t4-sidebar-bg:      #eaece8;\n     --t4-sidebar-header:  #e0e4de;\n     --t4-code-bg:         #f7f9f5;\n     --t4-eq-bg:           #f4f7f3;\n   \n     --t4-accent:          #2c5f2d;\n     --t4-accent-dim:      rgba(44, 95, 45, 0.08);\n     --t4-accent-glow:     rgba(44, 95, 45, 0.18);\n     --t4-accent-hover:    #1e3f1f;\n   \n     --t4-amber:           #d4a017;\n     --t4-amber-dim:       rgba(212, 160, 23, 0.10);\n     --t4-amber-border:    rgba(212, 160, 23, 0.28);\n     --t4-cyan:            #2c7a6e;\n     --t4-cyan-dim:        rgba(44, 122, 110, 0.08);\n     --t4-cyan-border:     rgba(44, 122, 110, 0.22);\n     --t4-blue:            #3a6b4b;\n     --t4-blue-dim:        rgba(58, 107, 75, 0.08);\n     --t4-blue-border:     rgba(58, 107, 75, 0.22);\n     --t4-green-dim:       rgba(44, 95, 45, 0.06);\n     --t4-green-border:    rgba(44, 95, 45, 0.20);\n   \n     --t4-batch:           #d4a017;\n     --t4-cstr:            #c45c2c;\n     --t4-pfr:             #3a6b4b;\n     --t4-pbr:             #2c5f2d;\n   \n     --t4-border:          #cbd5c5;\n     --t4-border-light:    #dee4da;\n     --t4-border-mid:      #b2bcac;\n   \n     --t4-text:            #1a2e1a;\n     --t4-text-muted:      #2a3e2a;\n     --t4-text-mid:        #3a5238;\n     --t4-text-dim:        #5a6e58;\n     --t4-text-sub:        #7a8e78;\n   \n     --t4-font-mono:   'DM Mono', 'JetBrains Mono', monospace;\n     --t4-font-ui:     'DM Sans', 'Segoe UI', system-ui, sans-serif;\n     --t4-font-brand:  'Syne', sans-serif;\n     --t4-font-serif:  'Source Serif 4', Georgia, serif;\n   \n     --t4-space-xs:  6px;\n     --t4-space-sm:  10px;\n     --t4-space-md:  16px;\n     --t4-space-lg:  24px;\n     --t4-space-xl:  40px;\n     --t4-space-2xl: 56px;\n   \n     --t4-radius-sm: 5px;\n     --t4-radius-md: 9px;\n     --t4-radius-lg: 13px;\n   \n     --t4-sidebar-w: 260px;\n   }\n   \n   /* ─── Reset ─────────────────────────────────────────────────── */\n   *,\n   *::before,\n   *::after {\n     box-sizing: border-box;\n     margin: 0;\n     padding: 0;\n   }\n   \n   /* ─── Scrollbar ─────────────────────────────────────────────── */\n   ::-webkit-scrollbar        { width: 5px; height: 5px; }\n   ::-webkit-scrollbar-track  { background: transparent; }\n   ::-webkit-scrollbar-thumb  { background: var(--t4-border); border-radius: 3px; }\n   ::-webkit-scrollbar-thumb:hover { background: var(--t4-border-mid); }\n   \n   /* ══════════════════════════════════════════════════════════════\n      CONTAINER\n   ══════════════════════════════════════════════════════════════ */\n   .cre4-container {\n     font-family: var(--t4-font-ui);\n     background:  var(--t4-bg);\n     color:       var(--t4-text);\n     display:     flex;\n     height:      100%;\n     width:       100%;\n     font-size:   15px;\n     line-height: 1.7;\n     overflow:    hidden;\n   }\n   \n   /* ══════════════════════════════════════════════════════════════\n      SIDEBAR\n   ══════════════════════════════════════════════════════════════ */\n   .cre4-sidebar {\n     display:        none;\n     width:          var(--t4-sidebar-w);\n     min-width:      var(--t4-sidebar-w);\n     background:     var(--t4-sidebar-bg);\n     border-right:   1px solid var(--t4-border);\n     height:         100%;\n     overflow-y:     auto;\n     padding-bottom: 40px;\n     font-size:      13px;\n     flex-shrink:    0;\n   }\n   \n   @media (min-width: 1600px) {\n     .cre4-sidebar { display: block; }\n   }\n   \n   .cre4-sidebar-header {\n     background:    var(--t4-sidebar-header);\n     padding:       20px 18px 16px;\n     border-bottom: 1px solid var(--t4-border);\n     position:      sticky;\n     top:           0;\n     z-index:       10;\n   }\n   \n   .cre4-sidebar-header h1 {\n     font-family:    var(--t4-font-mono);\n     font-size:      11px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t4-accent);\n     margin-bottom:  4px;\n     font-weight:    500;\n   }\n   \n   .cre4-sidebar-header p {\n     font-size: 12px;\n     color:     var(--t4-text-muted);\n   }\n   \n   .cre4-nav-section {\n     padding:        14px 0 4px 18px;\n     font-family:    var(--t4-font-mono);\n     font-size:      10px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t4-amber);\n     margin-top:     8px;\n     font-weight:    500;\n   }\n   \n   .cre4-nav-item {\n     display:      block;\n     padding:      7px 18px 7px 28px;\n     color:        var(--t4-text-muted);\n     text-decoration: none;\n     border-left:  3px solid transparent;\n     transition:   all 0.15s;\n     line-height:  1.4;\n     cursor:       pointer;\n   }\n   .cre4-nav-item:hover {\n     color:             var(--t4-text);\n     background:        var(--t4-accent-dim);\n     border-left-color: var(--t4-accent);\n   }\n   .cre4-nav-item--sub {\n     padding-left: 40px;\n     font-size:    12px;\n     color:        var(--t4-text-dim);\n   }\n   \n   /* ══════════════════════════════════════════════════════════════\n      MAIN CONTENT\n   ══════════════════════════════════════════════════════════════ */\n   .cre4-main {\n     flex:       1;\n     overflow-y: auto;\n     overflow-x: hidden;\n     min-width:  0;\n     animation:  fadeIn4 0.3s ease;\n   }\n   \n   .cre4-main-inner {\n     margin:  0 auto;\n     padding: 48px 56px 80px;\n   }\n   \n   /* ─── Hero ──────────────────────────────────────────────────── */\n   .cre4-hero {\n     margin-bottom:  var(--t4-space-2xl);\n     padding-bottom: 32px;\n     border-bottom:  1px solid var(--t4-border-light);\n   }\n   \n   .cre4-hero-tag {\n     font-family:    var(--t4-font-mono);\n     font-size:      11px;\n     text-transform: uppercase;\n     letter-spacing: 3px;\n     color:          var(--t4-amber);\n     margin-bottom:  12px;\n   }\n   \n   .cre4-hero h1 {\n     font-family:   var(--t4-font-serif);\n     font-size:     38px;\n     font-weight:   700;\n     line-height:   1.2;\n     margin-bottom: 12px;\n     color:         var(--t4-text);\n   }\n   \n   .cre4-hero-desc {\n     color:     var(--t4-text-muted);\n     font-size: 16px;\n     max-width: 620px;\n     line-height: 1.6;\n   }\n   \n   .cre4-hero-meta {\n     display:    flex;\n     gap:        24px;\n     margin-top: 20px;\n     flex-wrap:  wrap;\n   }\n   \n   .cre4-meta-item {\n     font-family: var(--t4-font-mono);\n     font-size:   11px;\n     color:       var(--t4-text-dim);\n     display:     flex;\n     align-items: center;\n     gap:         6px;\n   }\n   \n   .cre4-meta-dot {\n     width:         6px;\n     height:        6px;\n     border-radius: 50%;\n     background:    var(--t4-accent);\n     display:       inline-block;\n   }\n   \n   /* ─── TOC box ───────────────────────────────────────────────── */\n   .cre4-toc-box {\n     background:    var(--t4-surface);\n     border:        1px solid var(--t4-border-light);\n     border-top:    3px solid var(--t4-blue);\n     border-radius: var(--t4-radius-lg);\n     padding:       22px 26px;\n     margin-bottom: var(--t4-space-2xl);\n   }\n   \n   .cre4-toc-box h3 {\n     font-family:    var(--t4-font-mono);\n     font-size:      11px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t4-text-dim);\n     margin-bottom:  14px;\n     font-weight:    500;\n   }\n   \n   .cre4-toc-grid {\n     display:               grid;\n     grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n     gap:                   6px 20px;\n   }\n   \n   .cre4-toc-link {\n     font-size:       13px;\n     color:           var(--t4-blue);\n     text-decoration: none;\n     padding:         4px 0;\n     transition:      color 0.15s;\n   }\n   .cre4-toc-link:hover { color: var(--t4-accent); text-decoration: underline; }\n   \n   /* ══════════════════════════════════════════════════════════════\n      DIAGRAM STYLES\n   ══════════════════════════════════════════════════════════════ */\n   \n   /* ─── Two Steps Diagram ─────────────────────────────────────── */\n   .cre4-two-steps-container {\n     background: var(--t4-surface);\n     border-radius: var(--t4-radius-lg);\n     padding: 24px;\n     margin: 24px 0;\n     border: 1px solid var(--t4-border-light);\n   }\n   \n   .cre4-two-steps-diagram {\n     display: flex;\n     align-items: center;\n     justify-content: space-between;\n     gap: 16px;\n     flex-wrap: wrap;\n   }\n   \n   .cre4-step-box {\n     flex: 1;\n     min-width: 180px;\n     padding: 20px;\n     border-radius: var(--t4-radius-md);\n     text-align: center;\n   }\n   \n   .cre4-step-box--rate {\n     background: var(--t4-cyan-dim);\n     border: 2px solid var(--t4-cyan);\n   }\n   \n   .cre4-step-box--stoich {\n     background: var(--t4-blue-dim);\n     border: 2px solid var(--t4-blue);\n   }\n   \n   .cre4-step-box--combine {\n     background: var(--t4-accent-dim);\n     border: 2px solid var(--t4-accent);\n   }\n   \n   .cre4-step-box-title {\n     font-family: var(--t4-font-mono);\n     font-size: 12px;\n     font-weight: 600;\n     margin-bottom: 12px;\n   }\n   \n   .cre4-step-box--rate .cre4-step-box-title { color: var(--t4-cyan); }\n   .cre4-step-box--stoich .cre4-step-box-title { color: var(--t4-blue); }\n   .cre4-step-box--combine .cre4-step-box-title { color: var(--t4-accent); }\n   \n   .cre4-step-box-eq {\n     font-family: var(--t4-font-mono);\n     font-size: 14px;\n     margin: 12px 0;\n     padding: 8px;\n     background: rgba(255,255,255,0.5);\n     border-radius: var(--t4-radius-sm);\n   }\n   \n   .cre4-step-box-desc {\n     font-size: 12px;\n     color: var(--t4-text-dim);\n   }\n   \n   .cre4-step-arrow {\n     font-size: 28px;\n     color: var(--t4-text-mid);\n     font-weight: bold;\n   }\n   \n   @media (max-width: 700px) {\n     .cre4-two-steps-diagram { flex-direction: column; }\n     .cre4-step-arrow { transform: rotate(90deg); }\n   }\n   \n   /* ─── Reactors Diagram ──────────────────────────────────────── */\n   .cre4-reactors-diagram {\n     display: flex;\n     justify-content: center;\n     gap: 32px;\n     margin: 24px 0;\n     padding: 20px;\n     background: var(--t4-surface);\n     border-radius: var(--t4-radius-lg);\n     border: 1px solid var(--t4-border-light);\n   }\n   \n   .cre4-reactor-icon {\n     text-align: center;\n   }\n   \n   .cre4-reactor-icon svg {\n     display: block;\n     margin: 0 auto;\n   }\n   \n   /* ─── Arrhenius Plot ────────────────────────────────────────── */\n   .cre4-arrhenius-container {\n     background: var(--t4-surface);\n     border-radius: var(--t4-radius-lg);\n     padding: 24px;\n     margin: 24px 0;\n     border: 1px solid var(--t4-border-light);\n   }\n   \n   .cre4-arrhenius-title {\n     font-family: var(--t4-font-mono);\n     font-size: 11px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color: var(--t4-text-dim);\n     margin-bottom: 16px;\n   }\n   \n   .cre4-arrhenius-svg {\n     width: 100%;\n     max-width: 500px;\n     display: block;\n     margin: 0 auto;\n   }\n   \n   .cre4-arrhenius-caption {\n     font-size: 12px;\n     color: var(--t4-text-sub);\n     text-align: center;\n     margin-top: 14px;\n     font-style: italic;\n   }\n   \n   /* ─── Stoichiometry Table Visual ─────────────────────────────── */\n   .cre4-stoich-table-visual {\n     background: var(--t4-surface);\n     border-radius: var(--t4-radius-lg);\n     border: 1px solid var(--t4-border);\n     overflow: hidden;\n     margin: 24px 0;\n   }\n   \n   .cre4-stoich-row {\n     display: grid;\n     grid-template-columns: 80px 1fr 1fr 1.5fr;\n     border-bottom: 1px solid var(--t4-border-light);\n   }\n   \n   .cre4-stoich-row > span {\n     padding: 12px 16px;\n     font-size: 13px;\n   }\n   \n   .cre4-stoich-header {\n     background: var(--t4-panel);\n     font-family: var(--t4-font-mono);\n     font-size: 10px;\n     text-transform: uppercase;\n     letter-spacing: 1px;\n     font-weight: 600;\n     color: var(--t4-text-dim);\n   }\n   \n   .cre4-stoich-header > span {\n     padding: 10px 16px;\n   }\n   \n   .cre4-stoich-species {\n     font-family: var(--t4-font-mono);\n     font-weight: 600;\n     color: var(--t4-text-mid);\n   }\n   \n   .cre4-stoich-result {\n     font-family: var(--t4-font-mono);\n     color: var(--t4-accent);\n     font-weight: 500;\n   }\n   \n   .cre4-stoich-total {\n     background: var(--t4-accent-dim);\n     border-top: 1px solid var(--t4-border);\n   }\n   \n   .cre4-stoich-equilibrium .cre4-stoich-total {\n     background: var(--t4-amber-dim);\n   }\n   \n   @media (max-width: 800px) {\n     .cre4-stoich-row {\n       grid-template-columns: 60px 1fr 1fr 1fr;\n       font-size: 11px;\n     }\n     .cre4-stoich-row > span { padding: 8px 12px; }\n   }\n   \n   /* ─── Algorithm Tower Diagram ───────────────────────────────── */\n   .cre4-algorithm-tower {\n     background: var(--t4-surface);\n     border-radius: var(--t4-radius-lg);\n     padding: 24px;\n     margin: 24px 0;\n     border: 1px solid var(--t4-border-light);\n     display: flex;\n     flex-direction: column;\n     align-items: center;\n     gap: 8px;\n   }\n   \n   .cre4-tower-block {\n     display: flex;\n     align-items: center;\n     gap: 20px;\n     width: 100%;\n     max-width: 500px;\n     padding: 16px 20px;\n     border-radius: var(--t4-radius-md);\n     transition: transform 0.2s;\n   }\n   \n   .cre4-tower-block:hover {\n     transform: translateX(8px);\n   }\n   \n   .cre4-tower-block--1 { background: rgba(212,160,23,0.10); border-left: 4px solid var(--t4-amber); }\n   .cre4-tower-block--2 { background: rgba(44,122,110,0.08); border-left: 4px solid var(--t4-cyan); }\n   .cre4-tower-block--3 { background: rgba(58,107,75,0.08); border-left: 4px solid var(--t4-blue); }\n   .cre4-tower-block--4 { background: rgba(44,95,45,0.08); border-left: 4px solid var(--t4-accent); }\n   \n   .cre4-tower-step {\n     width: 40px;\n     height: 40px;\n     background: var(--t4-accent);\n     color: white;\n     border-radius: 50%;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     font-family: var(--t4-font-mono);\n     font-weight: bold;\n     font-size: 18px;\n     flex-shrink: 0;\n   }\n   \n   .cre4-tower-block--1 .cre4-tower-step { background: var(--t4-amber); }\n   .cre4-tower-block--2 .cre4-tower-step { background: var(--t4-cyan); }\n   .cre4-tower-block--3 .cre4-tower-step { background: var(--t4-blue); }\n   \n   .cre4-tower-content {\n     flex: 1;\n   }\n   \n   .cre4-tower-content h4 {\n     font-size: 15px;\n     font-weight: 600;\n     color: var(--t4-text-mid);\n     margin-bottom: 4px;\n   }\n   \n   .cre4-tower-content p {\n     font-size: 12px;\n     color: var(--t4-text-dim);\n     margin: 0;\n   }\n   \n   .cre4-tower-equation {\n     margin-top: 8px;\n     font-family: var(--t4-font-mono);\n     font-size: 11px;\n     color: var(--t4-blue);\n   }\n   \n   .cre4-tower-arrow {\n     font-size: 20px;\n     color: var(--t4-text-mid);\n   }\n   \n   /* ══════════════════════════════════════════════════════════════\n      EXISTING STYLES (from previous version)\n   ══════════════════════════════════════════════════════════════ */\n   \n   /* ─── Lecture badge ─────────────────────────────────────────── */\n   .cre4-lec-badge {\n     display:        inline-block;\n     font-family:    var(--t4-font-mono);\n     font-size:      10px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     padding:        3px 9px;\n     border-radius:  var(--t4-radius-sm);\n     margin-bottom:  10px;\n     font-weight:    500;\n   }\n   \n   .cre4-lec-badge--block1 {\n     background: rgba(212, 160, 23, 0.10);\n     color:      var(--t4-amber);\n     border:     1px solid var(--t4-amber-border);\n   }\n   .cre4-lec-badge--block2 {\n     background: var(--t4-cyan-dim);\n     color:      var(--t4-cyan);\n     border:     1px solid var(--t4-cyan-border);\n   }\n   .cre4-lec-badge--block3 {\n     background: var(--t4-blue-dim);\n     color:      var(--t4-blue);\n     border:     1px solid var(--t4-blue-border);\n   }\n   \n   /* ─── Section ───────────────────────────────────────────────── */\n   .cre4-section {\n     margin-bottom: var(--t4-space-2xl);\n     scroll-margin-top: 24px;\n   }\n   \n   .cre4-section-label {\n     font-family:    var(--t4-font-mono);\n     font-size:      10px;\n     text-transform: uppercase;\n     letter-spacing: 2.5px;\n     color:          var(--t4-text-sub);\n     margin-bottom:  6px;\n   }\n   \n   .cre4-section h2 {\n     font-family:   var(--t4-font-serif);\n     font-size:     26px;\n     font-weight:   700;\n     color:         var(--t4-text);\n     margin-bottom: 6px;\n     line-height:   1.3;\n   }\n   \n   .cre4-section-divider {\n     width:         40px;\n     height:        3px;\n     background:    var(--t4-accent);\n     margin-bottom: 22px;\n     border-radius: 2px;\n   }\n   \n   .cre4-section p {\n     margin-bottom: 14px;\n     color:         var(--t4-text-muted);\n     line-height:   1.75;\n   }\n   \n   /* ─── Equation box ──────────────────────────────────────────── */\n   .cre4-eq-box {\n     background:    var(--t4-eq-bg);\n     border:        1px solid var(--t4-border-light);\n     border-left:   3px solid var(--t4-amber);\n     border-radius: var(--t4-radius-md);\n     padding:       18px 22px;\n     margin:        18px 0;\n     overflow-x:    auto;\n   }\n   \n   .cre4-eq-label {\n     font-size:      10px;\n     font-family:    var(--t4-font-mono);\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t4-text-dim);\n     margin-bottom:  8px;\n   }\n   \n   .cre4-eq-main {\n     font-family: var(--t4-font-mono);\n     font-size:   14px;\n     color:       var(--t4-blue);\n     line-height: 2;\n   }\n   \n   .cre4-eq-note {\n     font-size:   12px;\n     color:       var(--t4-text-dim);\n     margin-top:  8px;\n     white-space: pre-line;\n     line-height: 1.6;\n   }\n   \n   /* ─── Callout boxes ─────────────────────────────────────────── */\n   .cre4-callout {\n     border-radius: var(--t4-radius-md);\n     padding:       14px 18px;\n     margin:        18px 0;\n     font-size:     14px;\n     line-height:   1.65;\n   }\n   .cre4-callout p  { color: var(--t4-text-muted); margin: 0; }\n   .cre4-callout--key  { background: var(--t4-blue-dim);  border: 1px solid var(--t4-blue-border);  }\n   .cre4-callout--warn { background: var(--t4-amber-dim); border: 1px solid var(--t4-amber-border); }\n   .cre4-callout--tip  { background: var(--t4-green-dim); border: 1px solid var(--t4-green-border); }\n   .cre4-callout--info { background: var(--t4-cyan-dim);  border: 1px solid var(--t4-cyan-border);  }\n   \n   /* ─── Card grid ─────────────────────────────────────────────── */\n   .cre4-card-grid {\n     display:               grid;\n     grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n     gap:                   14px;\n     margin:                20px 0;\n   }\n   \n   .cre4-card {\n     background:    var(--t4-surface);\n     border:        1px solid var(--t4-border-light);\n     border-radius: var(--t4-radius-md);\n     padding:       16px 18px;\n     transition:    border-color 0.18s, box-shadow 0.18s;\n     box-shadow:    0 1px 4px rgba(0,0,0,0.04);\n   }\n   .cre4-card:hover {\n     border-color: var(--t4-accent);\n     box-shadow:   0 4px 14px var(--t4-accent-glow);\n   }\n   .cre4-card-icon  { font-size: 22px; margin-bottom: 8px; }\n   .cre4-card h4    { font-size: 14px; font-weight: 600; color: var(--t4-text-mid); margin-bottom: 6px; }\n   .cre4-card p     { font-size: 13px; color: var(--t4-text-muted); margin: 0; line-height: 1.5; }\n   \n   /* ─── Steps list ────────────────────────────────────────────── */\n   .cre4-steps { margin: 20px 0; }\n   \n   .cre4-step {\n     display:       flex;\n     gap:           16px;\n     margin-bottom: 20px;\n     align-items:   flex-start;\n   }\n   \n   .cre4-step-num {\n     min-width:       32px;\n     height:          32px;\n     background:      var(--t4-accent);\n     color:           #fff;\n     border-radius:   50%;\n     display:         flex;\n     align-items:     center;\n     justify-content: center;\n     font-family:     var(--t4-font-mono);\n     font-weight:     600;\n     font-size:       13px;\n     flex-shrink:     0;\n     box-shadow:      0 2px 8px var(--t4-accent-glow);\n   }\n   .cre4-step-content { flex: 1; }\n   .cre4-step-content h4 { font-size: 14px; font-weight: 600; color: var(--t4-text-mid); margin-bottom: 6px; }\n   \n   /* ─── Tables ────────────────────────────────────────────────── */\n   .cre4-table {\n     width:           100%;\n     border-collapse: collapse;\n     margin:          20px 0;\n     font-size:       13px;\n     background:      var(--t4-surface);\n     border-radius:   var(--t4-radius-md);\n     overflow:        hidden;\n     border:          1px solid var(--t4-border-light);\n   }\n   .cre4-table thead { background: var(--t4-panel); }\n   .cre4-table th    { padding: 10px 14px; text-align: left; font-family: var(--t4-font-mono); font-size: 10px; text-transform: uppercase; letter-spacing: 1.5px; color: var(--t4-text-muted); border-bottom: 1px solid var(--t4-border); font-weight: 500; }\n   .cre4-table td    { padding: 10px 14px; border-bottom: 1px solid var(--t4-border-light); color: var(--t4-text-muted); vertical-align: middle; }\n   .cre4-table tr:last-child td { border-bottom: none; }\n   \n   /* ─── Reactor type badges ───────────────────────────────────── */\n   .cre4-badge {\n     display:        inline-block;\n     font-family:    var(--t4-font-mono);\n     font-size:      10px;\n     text-transform: uppercase;\n     letter-spacing: 1.5px;\n     padding:        3px 8px;\n     border-radius:  var(--t4-radius-sm);\n     font-weight:    600;\n     white-space:    nowrap;\n   }\n   .cre4-badge--batch { background: rgba(212,160,23,0.12); color: var(--t4-batch); border: 1px solid rgba(212,160,23,0.25); }\n   .cre4-badge--cstr  { background: rgba(196,92,44,0.12);  color: var(--t4-cstr);  border: 1px solid rgba(196,92,44,0.25); }\n   .cre4-badge--pfr   { background: var(--t4-blue-dim);    color: var(--t4-pfr);   border: 1px solid var(--t4-blue-border); }\n   .cre4-badge--pbr   { background: var(--t4-green-dim);   color: var(--t4-pbr);   border: 1px solid var(--t4-green-border); }\n   \n   /* ─── Reactor block ─────────────────────────────────────────── */\n   .cre4-reactor-block {\n     border-radius: var(--t4-radius-md);\n     overflow:      hidden;\n     margin:        20px 0;\n     border:        1px solid var(--t4-border-light);\n     box-shadow:    0 1px 6px rgba(0,0,0,0.05);\n   }\n   \n   .cre4-reactor-block-header {\n     padding:     10px 18px;\n     font-family: var(--t4-font-mono);\n     font-size:   11px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     font-weight: 600;\n   }\n   .cre4-reactor-block-body {\n     padding: 18px 20px;\n     background: var(--t4-surface);\n   }\n   \n   .cre4-reactor-block--batch .cre4-reactor-block-header {\n     background:    rgba(212,160,23,0.10);\n     color:         var(--t4-batch);\n     border-bottom: 1px solid rgba(212,160,23,0.18);\n   }\n   .cre4-reactor-block--cstr .cre4-reactor-block-header {\n     background:    rgba(196,92,44,0.10);\n     color:         var(--t4-cstr);\n     border-bottom: 1px solid rgba(196,92,44,0.18);\n   }\n   .cre4-reactor-block--pfr .cre4-reactor-block-header {\n     background:    var(--t4-blue-dim);\n     color:         var(--t4-pfr);\n     border-bottom: 1px solid var(--t4-blue-border);\n   }\n   .cre4-reactor-block--pbr .cre4-reactor-block-header {\n     background:    var(--t4-green-dim);\n     color:         var(--t4-pbr);\n     border-bottom: 1px solid var(--t4-green-border);\n   }\n   \n   /* ─── Footer ────────────────────────────────────────────────── */\n   .cre4-footer {\n     border-top:  1px solid var(--t4-border-light);\n     padding-top: 24px;\n     margin-top:  40px;\n     color:       var(--t4-text-dim);\n     font-family: var(--t4-font-mono);\n     font-size:   11px;\n   }\n   \n   /* ─── Animation ─────────────────────────────────────────────── */\n   @keyframes fadeIn4 {\n     from { opacity: 0; transform: translateY(4px); }\n     to   { opacity: 1; transform: translateY(0); }\n   }\n   \n   /* ─── Katex overrides ───────────────────────────────────────── */\n   .katex { font-size: 1.05em; }\n   .katex-display { margin: 0.8em 0; overflow-x: auto; overflow-y: hidden; }\n   \n   /* ─── Responsive ────────────────────────────────────────────── */\n   @media (max-width: 1200px) {\n     .cre4-main-inner { padding: 36px 36px 60px; }\n   }\n   \n   @media (max-width: 900px) {\n     .cre4-sidebar { display: none !important; }\n     .cre4-main-inner { padding: 24px 20px 60px; }\n     .cre4-toc-grid { grid-template-columns: 1fr 1fr; }\n   }\n   \n   @media (max-width: 600px) {\n     .cre4-card-grid { grid-template-columns: 1fr; }\n     .cre4-hero h1 { font-size: 26px; }\n     .cre4-toc-grid { grid-template-columns: 1fr; }\n     .cre4-step { flex-direction: column; gap: 8px; }\n   }\n   /* ══════════════════════════════════════════════════════════════\n      REACTORS IN SERIES DIAGRAM\n   ══════════════════════════════════════════════════════════════ */\n   \n   .cre4-series-diagram-container {\n     background: var(--t4-surface);\n     border-radius: var(--t4-radius-lg);\n     padding: 24px;\n     margin: 24px 0;\n     border: 1px solid var(--t4-border-light);\n     box-shadow: 0 2px 10px rgba(0,0,0,0.04);\n   }\n   \n   .cre4-series-title {\n     font-family: var(--t4-font-mono);\n     font-size: 11px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color: var(--t4-text-dim);\n     margin-bottom: 20px;\n     text-align: center;\n   }\n   \n   .cre4-series-diagram {\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     gap: 20px;\n     flex-wrap: wrap;\n     margin-bottom: 20px;\n   }\n   \n   .cre4-series-reactor {\n     display: flex;\n     flex-direction: column;\n     align-items: center;\n     justify-content: center;\n     width: 120px;\n     height: 100px;\n     border-radius: var(--t4-radius-md);\n     border: 2px solid;\n     padding: 12px;\n     text-align: center;\n     transition: transform 0.2s ease, box-shadow 0.2s ease;\n   }\n   \n   .cre4-series-reactor:hover {\n     transform: translateY(-4px);\n     box-shadow: 0 6px 16px rgba(0,0,0,0.1);\n   }\n   \n   .cre4-series-reactor--cstr {\n     background: rgba(196, 92, 44, 0.08);\n     border-color: var(--t4-cstr);\n   }\n   \n   .cre4-series-reactor--pfr {\n     background: rgba(58, 107, 75, 0.08);\n     border-color: var(--t4-pfr);\n     border-radius: 60px;\n   }\n   \n   .cre4-series-reactor-label {\n     font-family: var(--t4-font-mono);\n     font-size: 11px;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     font-weight: 600;\n   }\n   \n   .cre4-series-reactor--cstr .cre4-series-reactor-label {\n     color: var(--t4-cstr);\n   }\n   \n   .cre4-series-reactor--pfr .cre4-series-reactor-label {\n     color: var(--t4-pfr);\n   }\n   \n   .cre4-series-reactor-vol {\n     font-family: var(--t4-font-mono);\n     font-size: 18px;\n     font-weight: 700;\n     color: var(--t4-text-mid);\n     margin: 6px 0;\n   }\n   \n   .cre4-series-reactor-x {\n     font-family: var(--t4-font-mono);\n     font-size: 12px;\n     color: var(--t4-accent);\n     background: var(--t4-accent-dim);\n     padding: 2px 8px;\n     border-radius: 20px;\n   }\n   \n   .cre4-series-arrow {\n     font-size: 28px;\n     color: var(--t4-text-mid);\n     font-weight: bold;\n   }\n   \n   .cre4-series-note {\n     text-align: center;\n     margin-top: 16px;\n     padding-top: 12px;\n     border-top: 1px dashed var(--t4-border-light);\n   }\n   \n   .cre4-series-warning {\n     font-family: var(--t4-font-mono);\n     font-size: 11px;\n     color: var(--t4-amber);\n     background: var(--t4-amber-dim);\n     padding: 6px 12px;\n     border-radius: 20px;\n     display: inline-block;\n   }\n   \n   /* Responsive adjustments for series diagram */\n   @media (max-width: 600px) {\n     .cre4-series-diagram {\n       flex-direction: column;\n       gap: 12px;\n     }\n     \n     .cre4-series-arrow {\n       transform: rotate(90deg);\n     }\n     \n     .cre4-series-reactor {\n       width: 140px;\n     }\n   }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
